<template>
  <div class="photo-placeholder">
    <span class="icon icon-image" :style="'font-size:' + fontSize + ';'"></span>
  </div>
</template>

<script setup lang="ts">
//defineProps fontSize

const { fontSize } = defineProps({
  fontSize: { type: String, default: '69px' }
})

</script>


<style scoped lang="scss">
.photo-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: var(--blue-highlight);
  border-radius: 8px;

  //fix to cover skeleton when it doesn't disappear
  z-index: 1;
  position: relative;

  .icon {
    margin-top: -10px;
    color: var(--blue);
    opacity: 0.5;
  }
}
</style>